<template>
  <header class="d-header d-support-header" :style="{boxShadow: (scrollTop>74?' 0 2px 4px rgba(0, 0, 0, .08)':'none')}">
    <div class="w df jcsb">
      <div class="df top-box">
        <dLogo height="70%"/>
        <dNav />
      </div>
      <div class="df" v-if="deviceType == 'pc'">
        <el-dropdown v-if="userInfo.nickName" size="medium">
          <div :class="userInfo.userVip == '1' ? 'user-info vip' : 'user-info'">
            <span class="ico"></span>
            <span>{{ userInfo.nickName }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="openLink('/support/service?type=1')"
              icon="el-icon-service"
              >产品咨询</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="openLink('/support/service?type=2')"
              icon="el-icon-edit"
              >提交工单</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="openLink('/support/service?type=3')"
              icon="el-icon-tickets"
              >服务记录</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="openLink('/support/service?type=4')"
              icon="el-icon-monitor"
              >产品预约</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="openLink('/support/service?type=5')"
              icon="el-icon-document"
              >预约记录</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="handleLogout"
              icon="el-icon-switch-button"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <div v-else @click="openLogin" class="user-info no-login">
          <span class="ico"></span>
          <span>未登录</span>
        </div>
        <div class="dianhua">
          <i class="iconfont icon-dianhua4 ico"></i>
          <span>400-888-6369</span>
        </div>
      </div>
    </div>
    <loginModal ref="loginModal" />
  </header>
</template>
<script>
import { mapActions } from 'vuex'
import dLogo from '@/components/layouts/d-logo'
import loginModal from '@/components/login-modal'
import dNav from './d-nav'
export default {
  components: { dLogo, dNav, loginModal },
  
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
    userInfo() {
      return this.$store.state.login.userInfo
    },
  },
  data() {
    return {
      scrollTop:0
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(['submitDelUserInfo']),
    openLogin() {
      this.$refs.loginModal.showModal()
    },

    openLink(path) {
      this.$router.push({ path })
    },
    handleLogout() {
      this.submitDelUserInfo()
      this.openLink('/support/home')
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
  },
}
</script>
<style scoped lang="scss">
</style>